export const RETRY_INVALID_SESSION_HEADER =
  'X-Shopify-Retry-Invalid-Session-Request';

export const APP_BRIDGE_URL =
  'https://cdn.shopify.com/shopifycloud/app-bridge.js';
